import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import InputComponent from "../../UI/InputComponent/InputComponent";
import BasicAddressData from "../BasicAddressData/BasicAddressData";

const ReviserDataReviserView = (props) => {
  const { selectedDropdownValue, reviserData } = props;
  const { dataFetched } = reviserData;

  if (dataFetched) {
    switch (selectedDropdownValue) {
      case 1:
        return (
          <>
            <Row>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.nazDrustva}
                  controlLabel={"Naziv društva"}
                  id={`naz-drustva-rev-data${props.id}`}
                />
              </Col>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.web}
                  controlLabel={"Adresa internetske stranice"}
                  id={`adresa-web-rev-data${props.id}`}
                />
              </Col>
            </Row>
            <BasicAddressData
              disabled
              hackId={"reviser-data"}
              objData={{ id: props.id, group: "reviserData" }}
              onChange={props.mappedUserInputHandler}
              address={reviserData}
              {...props}
            />
          </>
        );

      case 2:
        return (
          <>
            <Row>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.prezime}
                  controlLabel={"Prezime"}
                />
              </Col>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.ime}
                  controlLabel={"Ime"}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.web}
                  controlLabel={"Adresa internetske stranice"}
                  id={`adrIntStr${props.id}`}
                />
              </Col>
              <Col></Col>
            </Row>
            <BasicAddressData
              disabled
              hackId={"reviser-data"}
              objData={{ id: props.id, group: "reviserData" }}
              onChange={props.mappedUserInputHandler}
              address={reviserData}
              {...props}
            />
          </>
        );
      case 3:
        return (
          <>
            <Row>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.nazDrustva}
                  controlLabel={"Naziv društva"}
                  id={`nazDrustva${props.id}`}
                />
              </Col>
              <Col>
                <InputComponent
                  disabled
                  value={reviserData.web}
                  controlLabel={"Adresa internetske stranice"}
                  id={`adrIntStr${props.id}`}
                />
              </Col>
            </Row>
            <BasicAddressData
              disabled
              hackId={"reviser-data"}
              objData={{ id: props.id, group: "reviserData" }}
              onChange={props.mappedUserInputHandler}
              address={reviserData}
              {...props}
            />
          </>
        );
      case 4 :
        return (
          <>
            {reviserData.ime && reviserData.prezime ? (
              <>
                <Row>
                  <Col>
                    <InputComponent
                      disabled
                      value={reviserData.prezime}
                      controlLabel={"Prezime"}
                    />
                  </Col>
                  <Col>
                    <InputComponent
                      disabled
                      value={reviserData.ime}
                      controlLabel={"Ime"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputComponent
                      disabled
                      value={reviserData.web}
                      controlLabel={"Adresa internetske stranice"}
                      id={`adrIntStr${props.id}`}
                    />
                  </Col>
                  <Col></Col>
                </Row>
              </>
            ) : (
              <Row>
                <Col>
                  <InputComponent
                    disabled
                    value={reviserData.nazDrustva}
                    controlLabel={"Naziv društva"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    disabled
                    value={reviserData.web}
                    controlLabel={"Adresa internetske stranice"}
                    id={`adrIntStr${props.id}`}
                  />
                </Col>
              </Row>
            )}

            <BasicAddressData
              disabled
              hackId={"reviser-data"}
              objData={{ id: props.id, group: "reviserData" }}
              onChange={props.mappedUserInputHandler}
              address={reviserData}
              {...props}
            />
          </>
        );
    }
  }

  return <></>;
};

export default ReviserDataReviserView;
